<!--
 * Created by JackCui on 2021/12/29
 -->

<script>
  export default {
    name: 'popup-render',
    props: {
      node: Object
    },
    provide () {
      return {
        pageType: 'popup'
      }
    },
    render (h) {
      return (
        <render viewContent={this.node.viewContent}/>
      )
    }
  }
</script>
